const menuData = {
    Accounts: [
        {
            label: "Accounting",
            submenus: [
                { label: "Overview", path: "/" },
                { label: "Balance and Movements", path: "/balance-and-movements" },
                { label: "Interest and Fees", path: "/interest-and-fees" }
            ]
        },
        {
            label: "Report Management",
            submenus: [
                { label: "Reports Panel", path: "/reports-panel" }
            ]
        },
    ],
    Payments: [
        {
            label: "Payment Actions",
            submenus: [
                { label: "New Payment", path: "/new-payment" },
                { label: "All Transactions", path: "/balance-and-movements" }
            ]
        },
        {
            label: "Balance",
            submenus: [
                { label: "Balance Sheet", path: "/balance-sheet" },
            ]
        },
        {
            label: "Schedules",
            submenus: [
                { label: "Scheduled Payments", path: "/scheduled-payments" },
            ]
        },
    ],
    Cards: [
        {
            label: "Card Services",
            submenus: [
                { label: "Debit Card", path: "#" },
                { label: "Credit Card", path: "#" },
                { label: "Safety Box", path: "#" }
            ]
        }
    ],
    Investments: [
        {
            label: "Investment Tools",
            submenus: [
                { label: "Portfolio", path: "#" },
                { label: "Market Watch", path: "#" },
                { label: "Reports", path: "#" }
            ]
        }
    ],
    Funding: [
        {
            label: "Manage Funds",
            submenus: [
                { label: "Add Funds", path: "#" },
                { label: "Withdraw", path: "/new-payment" },
                { label: "History", path: "#" },

            ]
        },
        {
            label: "Other",
            submenus: [
                { label: "Safety Box", path: "#" },
                { label: "Mortage loan", path: "#" },
                { label: "Car Leasing", path: "#" },

            ]
        },
    ],
    Services: [
        {
            label: "Trading",
            submenus: [
                { label: "Trading Account", path: "#" },
                { label: "CFD", path: "#" },
                { label: "EFT, ETC & ETN", path: "#" },
                { label: "Bonds", path: "#" },
                { label: "Futures", path: "#" }
            ]
        },
        {
            label: "Investing",
            submenus: [
                { label: "Invest in Assets", path: "#" },
                { label: "Pension", path: "#" },
                { label: "Consult", path: "#" }
            ]
        },
    ],
    Insurance: [
        {
            label: "Coverage",
            submenus: [
                { label: "Get a Quote", path: "/insurance/get-a-quote" },
                { label: "My Policies", path: "#" },
                { label: "Claims", path: "#" }
            ]
        }
    ],
};

export default menuData;